import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import React, {Component} from 'react';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import { Message } from 'primereact/message';
import { Messages } from 'primereact/messages';
import servicio from '../servicio/LicenciaServicio'
import token from '../componente/Token';
class Login extends Component{

    constructor(props){
        super(props);
        this.state={
            login:"",
            password:""
        }
        this.login=this.login.bind(this);
        //this.navigate= useNavigate();
    }

    login(){
        var data={
            login:this.state.login,
            password:this.state.password
        }
        servicio.login(data)
        .then((response) =>{   
            console.log(response);
            if(response.status===200&&response.data.status===true){
                console.log(response.data)
                token.setData(response.data);
                window.location.href = "/";
            }else if(response.status===200){
                token.clear();
                this.msgs3.clear();
                this.msgs3.show({
                    severity: 'error', sumary:"Error", detail:response.data.msg
                });
                this.setState({login:"",password:""});
            }else{
                token.clear();
                this.msgs3.clear();
                this.msgs3.show({
                    severity: 'error', sumary:"Error", detail:"Error en servidor"
                });
                this.setState({login:"",password:""});
            }
        }).catch( (err) =>{ 
            console.log(err);
            token.clear();
                this.msgs3.clear();
                this.msgs3.show({
                    severity: 'error', sumary:"Error", detail:"No existe conexion al servidor"
                });
                this.setState({login:"",password:""});
        });
    }
    render(){
        return(
            
            <div className="flex align-items-center justify-content-center">
                <br/>
                <p></p>
                <br></br>
                <br></br>
                <div className="surface-card p-4 shadow-2 border-round w-full lg:w-3">
                    <div className="text-center mb-5">
                        {/*<img src="" alt="hyper" height={50} className="mb-3" />*/}
                        <div className="text-900 text-3xl font-medium mb-3">INGRESO SISTEMA</div>
                    </div>
                    <div >
                        <label htmlFor="login" className="block text-900 font-medium mb-2">Login</label>
                        <InputText id="login" type="text" className="w-full mb-3" value={this.state.login} onChange={(e) => this.setState({login:e.target.value})}/>
                        <label htmlFor="password" className="block text-900 font-medium mb-2">Contraseña</label>
                        <InputText id="password" type="password" className="w-full mb-3" value={this.state.password}  onChange={(e) => this.setState({password:e.target.value})}/>
                        <Button label="Ingresar" icon="pi pi-user" className="w-full p-button-success" onClick={() => this.login()}/>
                        <Messages ref={(el) => this.msgs3 = el} />
                        
                    </div>
                </div>
            </div>
        );
    }
}
export default Login;